import { render, staticRenderFns } from "./publicPage.vue?vue&type=template&id=58122f9f&scoped=true&"
import script from "./publicPage.vue?vue&type=script&lang=ts&"
export * from "./publicPage.vue?vue&type=script&lang=ts&"
import style0 from "./publicPage.vue?vue&type=style&index=0&id=58122f9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58122f9f",
  null
  
)

export default component.exports